import { render, staticRenderFns } from "./wakeUpSetting.vue?vue&type=template&id=f9bfc854&scoped=true&"
import script from "./wakeUpSetting.vue?vue&type=script&lang=js&"
export * from "./wakeUpSetting.vue?vue&type=script&lang=js&"
import style0 from "./wakeUpSetting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wakeUpSetting.vue?vue&type=style&index=1&id=f9bfc854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bfc854",
  null
  
)

component.options.__file = "wakeUpSetting.vue"
export default component.exports